module.exports = __webpack_public_path__ + "static/fonts/2029e71f-067d-46a8-bc44-b5c64a258928.daa6dec.woff2";